import React, { useState, useEffect } from 'react';
import './CreditNote.css';

const CreditNote = () => {
    const [formData, setFormData] = useState({
        noteNo: '',
        date: '',
        customerName: '',
        particulars: '',
        remark: '',
        amount: '',
    });

    // Auto-generate Note No. on component mount
    useEffect(() => {
        const generatedNoteNo = 'CN-' + Date.now(); // You can use UUID or backend value
        setFormData(prev => ({ ...prev, noteNo: generatedNoteNo }));
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAdd = () => {
        console.log('Add:', formData);
        alert('Credit Note Added');
        // Optional: Reset form with new Note No
        const newNoteNo = 'CN-' + Date.now();
        setFormData({
            noteNo: newNoteNo,
            date: '',
            customerName: '',
            particulars: '',
            remark: '',
            amount: '',
        });
    };

    const handleModify = () => {
        console.log('Modify:', formData);
        alert('Credit Note Modified');
    };

    const handleDelete = () => {
        console.log('Delete:', formData);
        alert('Credit Note Deleted');
    };

    return (
        <div className="credit-note-container">
            <h3 className="text-center">Credit Note</h3>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="form-row">
                            <label>Note No.</label>
                            <input type="text" name="noteNo" value={formData.noteNo} readOnly />


                        </div>

                    </div>
                    <div className="col-lg-6">

                        <div className="form-row">
                            <label>Date</label>
                            <input type="date" name="date" value={formData.date} onChange={handleChange} />

                        </div>
                    </div>
                </div>
            </div>

            <div className="form-row">
                <label>Customer Name</label>
                <select name="customerName" value={formData.customerName} onChange={handleChange}>
                    <option value="">-- Select --</option>
                    <option value="Customer 1">Customer 1</option>
                    <option value="Customer 2">Customer 2</option>
                </select>
            </div>

            <div className="form-row">
                <label>Particulars</label>
                <input type="text" name="particulars" value={formData.particulars} onChange={handleChange} />
            </div>

            <div className="form-row">
                <label>Remark</label>
                <input type="text" name="remark" value={formData.remark} onChange={handleChange} />
            </div>

            <div className="form-row">
                <label>Amount</label>
                <input type="text" name="amount" value={formData.amount} onChange={handleChange} />
            </div>

            <div className="button-group">
                <button className="btn-add" onClick={handleAdd}>Add</button>
                <button className="btn-success" onClick={handleAdd}>Save</button>
                <button className="btn-modify" onClick={handleModify}>Modify</button>
                <button className="btn-delete" onClick={handleDelete}>Delete</button>
                <button className="btn-close">X</button>
            </div>
        </div>
    );
};

export default CreditNote;
